import React from 'react'

function TeslaLogo() {
  return (
    <svg
      width="134"
      height="28"
      viewBox="0 0 134 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5016 27.8792L18.4188 5.84888C22.1525 5.84888 23.3302 6.25831 23.5003 7.92947C23.5003 7.92947 26.005 6.99556 27.2682 5.09882C22.3386 2.81451 17.3854 2.71149 17.3854 2.71149L14.4951 6.23181L14.5016 6.23136L11.6113 2.71094C11.6113 2.71094 6.65802 2.81407 1.729 5.09838C2.99118 6.99512 5.49688 7.92903 5.49688 7.92903C5.66791 6.25775 6.84418 5.84833 10.5529 5.84568L14.5016 27.8792Z"
        fill="#E82127"
      />
      <path
        d="M14.5005 1.69601C18.4854 1.66553 23.0467 2.31246 27.716 4.34756C28.3401 3.22429 28.5005 2.72785 28.5005 2.72785C23.3962 0.708436 18.6162 0.0173355 14.4999 0C10.3839 0.0173355 5.60407 0.708546 0.500488 2.72785C0.500488 2.72785 0.728168 3.33934 1.28445 4.34756C5.95288 2.31246 10.5149 1.66553 14.4999 1.69601H14.5005Z"
        fill="#E82127"
      />
      <path
        d="M36.5005 7.64546C36.7831 8.74783 37.7376 9.87457 39.047 10.1569H43.0047L43.2066 10.2366V20.2233H45.678V10.2366L45.9025 10.1569H49.8636C51.1877 9.81574 52.1216 8.74783 52.3994 7.64546V7.62109H36.5005V7.64546Z"
        fill="#E82127"
      />
      <path
        d="M60.9566 20.2508H70.3586C71.6667 19.9907 72.6389 18.8383 72.9115 17.7227H58.4038C58.6746 18.8386 59.6611 19.9907 60.9566 20.2508Z"
        fill="#E82127"
      />
      <path
        d="M60.9566 15.1293H70.3586C71.6667 14.8714 72.6389 13.7186 72.9115 12.6016H58.4038C58.6746 13.7189 59.6611 14.8714 60.9566 15.1293Z"
        fill="#E82127"
      />
      <path
        d="M60.9566 10.146H70.3586C71.6667 9.88527 72.6389 8.73348 72.9115 7.61719H58.4038C58.6746 8.73348 59.6611 9.88527 60.9566 10.146Z"
        fill="#E82127"
      />
      <path
        d="M82.4006 10.1206H91.0866C92.3961 9.74016 93.4957 8.74257 93.7637 7.63672H79.9658V15.0909H91.2589V17.7067L82.4006 17.7136C81.0125 18.1007 79.8353 19.0329 79.248 20.264L79.9658 20.2508H93.6854V12.6125H82.4006V10.1206Z"
        fill="#E82127"
      />
      <path
        d="M111.959 20.2535C113.193 19.7307 113.856 18.8264 114.11 17.7682H103.14L103.147 7.63281L100.688 7.63977V20.2535H111.959Z"
        fill="#E82127"
      />
      <path
        d="M121.543 10.1567H130.948C132.254 9.897 133.226 8.74416 133.5 7.62891H118.991C119.262 8.7445 120.248 9.897 121.543 10.1567Z"
        fill="#E82127"
      />
      <path
        d="M119.37 12.625V20.2521H121.816V15.174H130.718V20.2521H133.162V12.6382L119.37 12.625Z"
        fill="#E82127"
      />
    </svg>
  )
}

export default TeslaLogo
